import React from "react";
import SkeletonLoader from "../Shimmer";

const InterestedCategoriesShimmer = () => {
  return <SkeletonLoader type={"paragraph"} count={10} width={100} />;
};

export default InterestedCategoriesShimmer;